import { Image } from 'src/components/common/Image';
import styles from './TwelveWeek.module.scss';

type TpTwelveWeekProps = {
  isChecked: boolean;
};
export const TwelveWeek = (props: TpTwelveWeekProps) => {
  const { isChecked } = props;

  return (
    <div
      className={styles.description}
      style={{
        margin: isChecked ? '0 auto 16px auto' : '16px auto 0 auto',
      }}
    >
      <Image
        alt=""
        width={20}
        height={20}
        src="busts_in_silhouette-emoji.webp"
      />
      <p>
        Usually Youth users with a 12-week plan are more motivated and lose
        weight 4.2 times faster
      </p>
    </div>
  );
};
